import makeStyles from '@mui/styles/makeStyles';
import { CircularProgress, styled } from "@mui/material";

export const LoadingStyled = styled(CircularProgress)(() => ({
  color: "#475467",
}));

const styles = makeStyles(() => ({
  actionButton: {
    cursor: "pointer",
  },
  menu: {
    width: "151px",
  },
  button: {
    height: "40px",
  },
  menuItem: {
    color: "#667085",
    fontWeight: 600,
    fontSize: "14px",
    fontFamily: "Manrope",
    minWidth: "148px",
    height: "40px",
  },
}));

export default styles;
